import { createEntityAdapter } from "@reduxjs/toolkit";
import { WebOrder } from "./dataTypes";

export const webOrderAdapter = createEntityAdapter<WebOrder>({});
